import { Button, Form, Select, Input, Skeleton, Row, Col, DatePicker } from 'antd';
import dayjs from 'dayjs';
import {
  CardHolderEditFormContainer,
  FormFooter,
} from 'components/card-holder.styles';
import {
  GenderPatch,
} from 'interfaces/card-holder';
import React, { useRef, useState } from 'react';
import useToastContext from '../../hooks/useToastContext';
import { Countries } from '../../constants';
import { PhoneFormInputs } from '../../components/Phones/phones';
import { IdentificationsFormInputs } from '../../components/Identifications/identifications';
import useUpdateCardHolder from '../../hooks/useUpdateCardHolder';

type CardHolderEditFormInputs = {
  // eslint-disable-next-line camelcase
  first_name: string;
  // eslint-disable-next-line camelcase
  last_name: string;
  // eslint-disable-next-line camelcase
  legal_name: string;
  // eslint-disable-next-line camelcase
  trade_name: string;
  email: string;
  // eslint-disable-next-line camelcase
  birth_date: string;
  // eslint-disable-next-line camelcase
  inscription_date: string;
  identifications: IdentificationsFormInputs[];
  nationality: string;
  phones: PhoneFormInputs[];
  gender: string;
  // eslint-disable-next-line camelcase
  external_id: string;
}

const CardHolderEditForm = ({ id, cardHolder, isPerson, closeCallback, getCardholder }) => {
  const toast = useToastContext();
  const [isLoading, setIsLoading] = useState(false);
  const changes = useRef({});
  const { updateCardholder } = useUpdateCardHolder(id);
  const [form] = Form.useForm();

  const sendValuesToBackend = async (request?: {} | undefined) => {
    const newRequest = [];
    setIsLoading(true);

    if (request) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      for (const [key, value] of Object.entries(changes.current)) {
        if (typeof value === 'object' && Object.keys(value).length > 0) {
          newRequest.push(value);
        } else if (value) {
          newRequest.push(value);
        }
      }
    }

    await updateCardholder({ data: newRequest })
      .then((response) => {
        if(response.status === 204)
          toast.success('Exito', '¡El titular se ha actualizado correctamente!');
        getCardholder();
        closeCallback();
      }, (err) => {
        console.log(err);
        toast.error('Error', `Ocurrió un error: ${err}, porfavor, intente nuevamente.`);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  const editCardHolder = (request?: React.MutableRefObject<{}>) => {
    form.validateFields()
      .then(() => {
        sendValuesToBackend(request?.current);
      }).catch(e => {
        console.log(e);
        toast.error('Error', 'Hay errores de validacion en los campos');
      });
  };

  const onChange = (key: string, path: string, value: any = '', operation: string = 'replace') => {
    changes.current[key] = {
      op: operation,
      path: path,
      value: value,
    };
  };

  return (
    <>
      {
        isLoading === true ? (
          <Skeleton />
        ) : (
          <CardHolderEditFormContainer>
            <Form<CardHolderEditFormInputs>
              form={form}
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              onFinishFailed={console.log}
              layout="horizontal"
              autoComplete="off"
            >
              {isPerson ? (
                <>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Form.Item<CardHolderEditFormInputs>
                        label="Nombre"
                        name="first_name"
                        initialValue={cardHolder?.first_name}
                        rules={[{ required: true, message: 'Por favor ingresar nombre.', max: 100 }]}
                      >
                        <Input
                          defaultValue={cardHolder?.first_name}
                          onChange={(e) => onChange('firstName', '/firstName', e.target.value)} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item<CardHolderEditFormInputs>
                        label="Apellido"
                        name="last_name"
                        initialValue={cardHolder?.last_name}
                        rules={[{ required: true, message: 'Por favor ingresar apellido.', max: 100 }]}
                      >
                        <Input
                          defaultValue={cardHolder?.last_name}
                          onChange={(e) => onChange('lastName', '/lastName', e.target.value)} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item<CardHolderEditFormInputs>
                        label="Fecha de nacimiento"
                        name="birth_date"
                        initialValue={dayjs(cardHolder?.birth_date)}
                        rules={[{ required: true, message: 'Por favor ingrese fecha de Nacimiento.' }]}
                      >
                        <DatePicker
                          format={'YYYY-MM-DD'}
                          onChange={( stringDate) => onChange('birthDate', '/birthDate', stringDate)} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={8}>
                      <Form.Item
                        label="Genero"
                        name="gender"
                        initialValue={cardHolder?.gender}
                        rules={[{ required: true, message: 'Por favor seleccione genero.', max: 50 }]}
                      >
                        <Select
                          placeholder="Seleccionar genero"
                          showSearch
                          options={Object.entries(GenderPatch).map(([, name]) => ({ label: name, value: name }))}
                          onChange={(value) => onChange('gender', '/gender', value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Nacionalidad"
                        name="nationality"
                        initialValue={cardHolder?.nationality}
                        rules={[{ required: true, message: 'Por favor ingrese nacionalidad.', max: 50 }]}
                      >
                        <Select
                          placeholder="Seleccionar pais"
                          showSearch
                          options={Object.entries(Countries).map(([code, name]) => ({ label: name, value: code }))}
                          onChange={(value) => onChange('nationality', '/nationality', value)}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row gutter={24}>
                  <Col span={8}>
                    <Form.Item<CardHolderEditFormInputs>
                      label="Nombre"
                      name="legal_name"
                      rules={[{ required: true, message: 'Por favor ingresar nombre.', max: 100 }]}
                      initialValue={cardHolder?.legal_name}
                    >
                      <Input onChange={(e) => onChange('legalName', '/legalName', e.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item<CardHolderEditFormInputs>
                      label="Razon social"
                      name="trade_name"
                      initialValue={cardHolder?.trade_name}
                      rules={[{ required: true, message: 'Por favor ingresar razon social.', max: 100 }]}
                    >
                      <Input onChange={(e) => onChange('tradeName', '/tradeName', e.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      label="Fecha de inscripcion"
                      name="inscription_date"
                      initialValue={dayjs(cardHolder?.inscription_date)}
                      rules={[{ required: true, message: 'Por favor ingrese fecha de inscripcion.' }]}

                    >
                      <DatePicker
                        format={'YYYY-MM-DD'}
                        onChange={(_, stringDate) => onChange('inscriptionDate', '/inscriptionDate', stringDate)} />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={24}>
                <Col span={8}>
                  <Form.Item<CardHolderEditFormInputs>
                    label="Email"
                    name="email"
                    initialValue={cardHolder?.email}
                    rules={[{ required: true, message: 'Por favor ingresar email.', max: 50 }]}
                  >
                    <Input onChange={(e) => onChange('email', '/email', e.target.value)} />
                  </Form.Item>
                </Col>

              </Row>
              <FormFooter>
                <Button
                  danger
                  style={{ marginRight: '10px' }}
                  onClick={() => closeCallback()}
                >
                  Cancelar
                </Button>
                <Button
                  style={{ marginRight: '10px' }}
                  type="primary"
                  onClick={() => {
                    editCardHolder(changes);
                  }}
                >
                  Guardar
                </Button>
              </FormFooter>
            </Form>
          </CardHolderEditFormContainer>
        )
      }
    </>
  );
};

export default CardHolderEditForm;